<!--<c-footer>-->
  <div class="footer-black-text" *transloco="let t">

    &copy; {{ year }} Peoplesafe Personal Safety Ltd - 
    <a href="https://www.okaloneworker.com/work-alone-monitoring-terms/" target="_new" style="color: #000000 !important;">{{ t('Terms') }}</a> - 
    <a href="https://www.okaloneworker.com/work-alone-monitoring-privacy/" target="_new" style="color: #000000 !important;">{{ t('Privacy') }}</a> - 
    <a href="https://www.okaloneworker.com/fair-use-policy/" target="_new" style="color: #000000 !important;">{{ t('Fair Use Policy') }}</a> - 
    <a href="https://www.okaloneworker.com/gdpr/" target="_new" style="color: #000000 !important;">GDPR/The Canadian Privacy Act</a> 
    {{ t(' - Version ') }}{{okService.version}}
  </div>
<!--</c-footer>-->
